import { ClubBookingApiClient } from "../../common/api/ClubBookingApiClient";
import { ClientSummary } from "../../model/fortius/ClientSummary";
import { CreateClientRequest, CreatedClient } from "../../model/fortius/CreateClientRequest";

// Super-admin only: surfaces the Fortius-level cross-tenant endpoints. The base
// class still injects X-Client-Id (the operator's "home" tenant) but these
// endpoints do not filter on it — they are gated server-side by the
// IsFortiusAdmin policy.
export class FortiusClientService extends ClubBookingApiClient {
    async listClients(): Promise<ClientSummary[]> {
        return this.get<ClientSummary[]>('/api/fortius/clients');
    }

    async createClient(request: CreateClientRequest): Promise<CreatedClient> {
        return this.post<CreatedClient>('/api/fortius/clients', request, {
            successMessage: `Created tenant "${request.name}"`,
        });
    }
}
